import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApplicationInsightsService {
  private appInsights: ApplicationInsights;

  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: environment.applicationInsights.connectionString,
        enableAutoRouteTracking: true,
        enableCorsCorrelation: true,
        enableUnhandledPromiseRejectionTracking: true,
        distributedTracingMode: 2,
      }
    });

    this.appInsights.loadAppInsights();
  }

  trackEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name }, properties);
  }

  trackPageView(name?: string, uri?: string) {
    this.appInsights.trackPageView({ name, uri });
  }

  trackException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ 
      exception,
      severityLevel
    });
  }

  trackMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name, average }, properties);
  }

  trackDependencyData(id: string, target: string, name: string, data: string, success: boolean, responseCode: number, duration: number) {
    this.appInsights.trackDependencyData({
      id,
      target,
      name,
      data,
      success,
      responseCode,
      duration
    });
  }

  setUserId(userId: string) {
    this.appInsights.setAuthenticatedUserContext(userId);
  }

  clearUserId() {
    this.appInsights.clearAuthenticatedUserContext();
  }

  startTrackPage(name?: string) {
    this.appInsights.startTrackPage(name);
  }

  stopTrackPage(name?: string, customProperties?: { [key: string]: any }) {
    this.appInsights.stopTrackPage(name, undefined, customProperties);
  }

  flush() {
    this.appInsights.flush();
  }
}